import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/replacement',
  component: LAYOUT,
  name: 'Replacement',
  redirect: '/replacement/index',
  meta: {
    title: '以旧换新',
  },
  children: [
    {
      path: 'index',
      name: 'ReplacementIndex',
      meta: {
        title: '以旧换新',
      },
      component: () => import('@/views/replacement/index'),
    },
    {
      path: 'detail',
      name: 'ReplacementDetail',
      meta: {
        title: '官方指南',
      },
      component: () => import('@/views/replacement/detail'),
    },
    {
      path: 'record',
      name: 'ReplacementRecord',
      meta: {
        title: '提交记录',
      },
      component: () => import('@/views/replacement/record'),
    },
  ],
};
